export default __webpack_public_path__ + "static/media/black.49131089.jpg";